import { DateTime } from '@otas/utils/custom-components/datetime-component/datetime';
import { Directive, Input, ElementRef, Renderer2, AfterViewInit, Optional, Self } from '@angular/core';

@Directive({
    selector: '[appDateTimeWidth]',
    standalone: false
})
export class DateTimeWidthDirective implements AfterViewInit {
    // tslint:disable-next-line:no-input-rename
    @Input('appDateTimeWidth') width = 227;
    constructor(private elementRef: ElementRef, private renderer: Renderer2, @Optional() @Self() private nkDatetime: DateTime) { }
    ngAfterViewInit() {
        const dateFormat = this.nkDatetime.datepickerRef().bsConfig.dateInputFormat;;
        const inputField = this.elementRef.nativeElement.querySelector('input');
        const parent = this.renderer.parentNode(inputField);
        this.renderer.addClass(inputField, 'form-control-sm');
        this.renderer.removeClass(parent, 'form-group');
        this.renderer.removeClass(parent, 'date')
        // console.log(this.width);
        switch (dateFormat) {
            case 'dd-MM-yyyy':
                this.renderer.setStyle(inputField, 'width', (this.width ? this.width : 227) + `px`); //300

                break;
            case 'dd/MM/yyyy':
                this.renderer.setStyle(inputField, 'width', (this.width ? this.width : 227) + `px`); //300
                break;

            default:

                this.renderer.setStyle(inputField, 'width', (this.width ? this.width : 120 )+ `px`); //120
                break;
        }
    }

}
